<!-- Assinatura Digital -->
<div class="timeline-badge">
  <a><em class="fa fa-circle"></em></a>
</div>

<h4 *ngIf="timelineActive">
  {{ timeline.dataHora | date : 'HH:mm' }}
  <small>{{ timeline.dataHora | date : 'dd/MM/yyyy' }}</small>
</h4>

<div
  class="timeline-panel"
  [ngClass]="{ 'timeline-panel-disabled': !timelineActive }"
>
  <div class="step">
    <span class="icon"></span>
    <h2>{{ timeline.tituloStatus }}</h2>
    <div class="assinatura-digital__mensagem" *ngIf="getStatusMessage()">
      {{ getStatusMessage() }}
    </div>
    <span>{{ timeline.subTituloStatus }}</span>

    <div *ngIf="timelineActive">
      <div class="required-documents-panel"></div>

      <div class="assinatura-digital__action-group">
        <div
          class="assinatura-digital__action-resend"
          *ngIf="hasResendButton()"
        >
          <button
            class="btn btn-border-orange assinatura-digital__action"
            (click)="onClickResend('3')"
          >
            Reenviar por WhatsApp
          </button>

          <button
            class="btn btn-border-orange assinatura-digital__action"
            (click)="onClickResend('1')"
          >
            Reenviar por Celular
          </button>

          <button
            class="btn btn-border-orange assinatura-digital__action"
            (click)="onClickResend('2')"
          >
            Reenviar por E-mail
          </button>
        </div>

        <button
          *ngIf="getPrintDocumentButton() && !isLojista"
          class="btn btn-border-orange assinatura-digital__action"
          (click)="onClickPrintDocument()"
        >
          <em class="fa fa-print"></em>
          {{ getPrintDocumentButton() }}
        </button>
      </div>
    </div>

    <div *ngIf="!timelineActive"><br /></div>
  </div>

 <app-timeline-status-signature *ngIf="timelineActive" [propostaId]="proposta.id"></app-timeline-status-signature>
</div>

<app-loader-circles *ngIf="isLoading"></app-loader-circles>
